import React from 'react';
import { IOrganization } from '@vivli/features/organizations/infrastructure/interface';
import { useActiveUserContext } from '@vivli/core/infrastructure/context';
import { OrgRorContainerComponent } from './ror/org-ror-container.component';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';

interface OrgRorTabComponentProps {
    organization: IOrganization;
}

export const OrgRorTabComponent = ({ organization }: OrgRorTabComponentProps) => {
    const { hasPermission } = useActiveUserContext();
    //TODO PERMFE - redo with permissions+
    const canEdit = hasPermission(PermissionsEnum.CreateOrg);

    return (
        <div>
            <OrgRorContainerComponent organization={organization} canEdit={canEdit} />
        </div>
    );
};
